import { render, staticRenderFns } from "./MobileRecipeCard.vue?vue&type=template&id=42c282d9&"
import script from "./MobileRecipeCard.vue?vue&type=script&lang=js&"
export * from "./MobileRecipeCard.vue?vue&type=script&lang=js&"
import style0 from "./MobileRecipeCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemActionText } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VCard,VImg,VListItem,VListItemActionText,VListItemAvatar,VListItemContent,VListItemTitle,VRating})
